import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { enviroment } from 'src/environments/environment';
import { CreateTaskRequest } from '../model/request/createTaskRequest';
import { Observable, tap } from 'rxjs';
import { UpdateTaskRequest } from '../model/request/updateTaskRequest';
import { Tasks } from '../model/tasks';
import { CreateTaskResponse } from '../model/request/createTaskResponse';
import { report } from 'process';

@Injectable({
  providedIn: 'root'
})
export class TasksService {

  userUrl: string
  globalUrl: string = enviroment.BASE_URL_API + '/global'
  httpOptions: {};

  httpOtionsProgress: {};

  constructor(private http: HttpClient) {
    this.httpOptions = {};
    this.userUrl = enviroment.BASE_URL_API + '/user';

    let idToken = sessionStorage.getItem('idToken') || ""
    this.httpOptions = {
      headers: new HttpHeaders({  
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${idToken}`
      })
    };

    this.httpOtionsProgress = {
      headers: new HttpHeaders({  
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${idToken}`
      }),
      reportProgress: true,
      observe: 'events'
    };

  }

  createTask(userId: string, task: CreateTaskRequest): Observable<HttpResponse<CreateTaskResponse>> {
     return this.http.post<CreateTaskResponse>(this.userUrl + `/createTask/${userId}`, task, {  ...this.httpOptions, observe: 'response' }).pipe(tap());
  }

  updateTask(userId: string, taskId: string, task: UpdateTaskRequest): Observable<HttpResponse<UpdateTaskRequest>> {
    
     return this.http.put(this.userUrl + `/updateTask/${userId}/${taskId}`, task, {  ...this.httpOptions, observe: 'response' }).pipe(tap());
  }

  getTaskList(userId: string, param: string): Observable<Tasks> {
    return this.http.get<Tasks>(this.userUrl + `/getTaskList/${userId}/${param}`, this.httpOptions).pipe(tap());
  }

  deleteTask(userId: string, taskId: string): Observable<any> {
    return this.http.delete<any>(this.userUrl + `/deleteTask/${userId}/${taskId}`, this.httpOptions).pipe(tap());
  }
  getTaskParameters(userId: string): Observable<any>{
    const language = sessionStorage.getItem('language')
    return this.http.get<any>(this.globalUrl + `/parameter_tasks?userID=${userId}&language=${language}`).pipe(tap());
  }
  getTaskResult(userId: string, taskId: string): Observable<any> {

    return this.http.get<any>(this.userUrl + `/getTaskResult/${userId}/${taskId}`, {... this.httpOptions, observe: 'events', reportProgress: true}).pipe(tap());
  }
}
